export default "__VITE_ASSET__BiV$FQyv__"